import React from "react";
import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

export const LeavePlanRejectConfirmDialog = ({ open, onCancel, onConfirm }) => {
    return (
        <Dialog open={open} onClose={onCancel} aria-labelledby="reject-leave-dialog-title">
            <DialogTitle id="reject-leave-dialog-title">Reject leave plan?</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    This action cannot be undone. Are you sure you want to reject this leave plan?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel}>Cancel</Button>
                <Button onClick={onConfirm} color="error" variant="contained">
                    Reject
                </Button>
            </DialogActions>
        </Dialog>
    );
};

LeavePlanRejectConfirmDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};
